import { AppState } from '../../store';

export const getBurningAccountSelector = (state: AppState) =>
  state.officialStatement.burningAccount;
export const getBurningTransactionsSelector = (state: AppState) =>
  state.officialStatement.burningTransactions;
